import { render } from "./mangerPage.vue?vue&type=template&id=7c970ade"
import script from "./mangerPage.vue?vue&type=script&lang=js"
export * from "./mangerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__